import React from "react";
import { useAuth } from "../../../contexts/auth.context";
import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";
import { useFormik } from "formik";
import { PasswordInput } from "../../ui/password-input";
import { initialValues, validationSchemas } from "../../../lib/forms-utils";

export const LoginForm: React.FC = () => {
  const { signInWithEmail, btnLoading } = useAuth();

  const formik = useFormik({
    initialValues: initialValues.login,
    validationSchema: validationSchemas.login,

    onSubmit: (values) => {
      signInWithEmail(values.email, values.password);
    },
  });

  return (
    <div className="flex flex-col w-full md:w-1/2 lg:w-1/3 bg-borderColor text-body border border-borderColor rounded-lg shadow-md p-4">
      <h1 className="text-2xl font-bold mb-4">Admin Only</h1>

      <form className="space-y-6" onSubmit={formik.handleSubmit}>
        <div>
          <Label htmlFor="email" className="block text-body mb-2 text-sm px-1">
            Email
          </Label>

          <Input
            name="email"
            type="email"
            id="email"
            placeholder="email@company.com"
            className="bg-transparent text-white placeholder"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.email && formik.errors.email
                ? formik.errors.email
                : ""
            }
          />
        </div>

        <div>
          <Label
            htmlFor="password"
            className="block text-body mb-2 text-sm px-1"
          >
            Password
          </Label>

          <PasswordInput
            name="password"
            id="password"
            placeholder="****"
            className="bg-transparent text-white placeholder"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.password && formik.errors.password
                ? formik.errors.password
                : ""
            }
          />
        </div>

        <div className="flex items-center justify-center w-full ">
          <Button loading={btnLoading} className="uppercase" type="submit">
            laten we gaan
          </Button>
        </div>
      </form>
    </div>
  );
};
